'use strict';

angular.module('jericho')
.value('logoutUrl', '/api/auth/logout')
.value('loginUrl', '/api/auth/login')
.value('twoFaLoginUrl', '/api/auth/login2fa')
.value('userUrl', '/api/auth/me')

.service('Auth', AuthService);

function AuthService (kdAuth,
                      $state,
                      $timeout,
                      $http,
                      DS,
                      logoutUrl,
                      userUrl,
                      twoFaLoginUrl,
                      loginUrl,
                      changePassword)
{
    this.loginTwoFa = function (data)
    {
        return $http.post(twoFaLoginUrl, data).then(function (response)
        {
            kdAuth.setUser(response.data);
            return kdAuth.user;
        });
    };

    this.login = function (data)
    {
        return $http.post(loginUrl, data).then(function (response)
        {
            if (response.data.status === 'two_fa') {
                return 'two_fa';
            }

            kdAuth.setUser(response.data);

            return kdAuth.user;
        });
    };

    this.logout = () =>
    {
        return $http.post(logoutUrl).then(function ()
        {
            DS.clear();
            kdAuth.setUser(null);
            $state.go('login');
        });
    };

    this.getCurrentUser = () =>
    {
        return kdAuth.user;
    };

    this.getUser = function () {

        return $http.get(userUrl).then(function (response) //jshint ignore:line
        {
            kdAuth.setUser(response.data);
            return kdAuth.user;
        });

    };

    this.editCurrentUser = () =>
    {
        new changePassword()
    };

    this.isLoggedIn = () =>
    {
        return !!kdAuth.user;
    };

    this.allowedAccess = () =>
    {
        $timeout(() => {
            if (!this.isLoggedIn()) {
                this.logout();
            }
        });
    };

}
